import { withDefault } from '@weft/utils';
import { withGlobalSearchParams } from 'apps/app/src/components/utility/GlobalSearchParamsBoundary';
import { useInvoiceStatistics } from 'apps/app/src/hooks/requests/use-invoices-statistics';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { useInvoicesOverviewsFromParams } from '../../../hooks/requests/use-invoices-overviews/use-invoices-overviews';
import { InvoicesPageContent } from './invoices-page-components/InvoicesPageContent';

const InvoicesPage: React.FC = () => {
  const { data: invoices, isFetching: isFetchingInvoicesOverviews } = useInvoicesOverviewsFromParams();
  const { data: invoicesStatistics } = useInvoiceStatistics();

  const invoicesOverviews = invoices?.invoicesOverviews ?? [];
  const invoicesOverviewsSummary = invoicesStatistics?.summary;

  return (
    <>
      <Helmet>
        <title>Invoices</title>
      </Helmet>

      <VyPageLayout
        title="Invoices"
      >
        <div className="flex h-full flex-col">
          <InvoicesPageContent
            invoices={invoicesOverviews}
            invoicesCount={withDefault(invoices?.count, 0)}
            loadingInvoices={isFetchingInvoicesOverviews}
            invoicesOverviewsSummary={invoicesOverviewsSummary}
          />
        </div>
      </VyPageLayout>
    </>
  );
};

const invoicesPageWithGlobalSearchParams = withGlobalSearchParams(InvoicesPage);
const InvoicesPageWithSuspenseBoundary = withSuspenseBoundary(invoicesPageWithGlobalSearchParams);
export { InvoicesPageWithSuspenseBoundary as InvoicesPage };